// extracted by mini-css-extract-plugin
export var container = "_6s-0";
export var fallback = "_6s-5";
export var fallbackIcon = "_6s-6";
export var hidden = "_6s-2";
export var image = "_6s-3";
export var loaded = "_6s-4";
export var placeholder = "_6s-1";